const memoryCache = new Map<string, SVGSVGElement>();

const LS_PREFIX = "svg-cache:";
export const SVG_CACHE_TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

type LocalEntry = {
  svgText: string;
  expiresAt: number;
};

const getLsKey = (url: string) => `${LS_PREFIX}${url}`;

export const getSvgFromMemory = (url: string): SVGSVGElement | null => {
  const svg = memoryCache.get(url);

  return svg || null;
};

export const setSvgToMemory = (url: string, svg: SVGSVGElement) => {
  memoryCache.set(url, svg);
};

export const getSvgFromLocalStorage = (url: string): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(getLsKey(url));

    if (!raw) {
      return null;
    }

    const data: LocalEntry = JSON.parse(raw);

    if (data.expiresAt < Date.now()) {
      window.localStorage.removeItem(getLsKey(url));
      return null;
    }

    return data.svgText;
  } catch (e) {
    console.error("[SVG] LOCALSTORAGE ERROR:", url, e);
    return null;
  }
};

export const setSvgToLocalStorage = (
  url: string,
  svgText: string,
  ttlMs: number = SVG_CACHE_TTL_MS
) => {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(
      getLsKey(url),
      JSON.stringify({
        svgText,
        expiresAt: Date.now() + ttlMs,
      })
    );
  } catch (e) {
    console.error("[SVG] FAILED TO SAVE TO LOCALSTORAGE:", url, e);
  }
};
